import { expandableRightBottomTriangle, expandableRightBottomQuadrant } from "../../../../views/grid/components/components.utils";
import { FabricTriangle } from "../../../../views/grid/components/FabricTriangle";
import { EXPANDABLE_TRIANGLE_CONFIG } from "./config/expandableTriangle.config";
import { SELECTED_CLASS_CONTAINER_TRIANGLE_STYLE, SELECTED_CLASS_CONTAINER_STYLE, DEFAULT_CLASS_CONTAINER_STYLE } from "./config/classContainer.config";

export class ContainerExpandableTriangle extends FabricTriangle {
    layout;

    state;

    ctx;

    config = EXPANDABLE_TRIANGLE_CONFIG;

    constructor(layout, state, ctx) {
        super();
        this.layout = layout;
        this.state = state;
        this.ctx = ctx;
    }

    draw() {
        const x = (this.layout.x + this.layout.width) - this.config.padding;
        const y = (this.layout.y + this.layout.height) - this.config.padding;
        const xQ = (this.layout.x + this.layout.width);
        const yQ = (this.layout.y + this.layout.height) - this.config.qPadding;
        const style = this.state.selected || this.state.childSelected ? SELECTED_CLASS_CONTAINER_TRIANGLE_STYLE : DEFAULT_CLASS_CONTAINER_STYLE;
        const qStyle = this.state.selected || this.state.childSelected ? SELECTED_CLASS_CONTAINER_STYLE : DEFAULT_CLASS_CONTAINER_STYLE;

        const points = [
            { x, y },
            { x, y: y - this.config.sideWidth },
            { x: x - this.config.sideWidth, y }
        ];
        this.setPoints(points);
        if (this.state.readonly) {
            return;
        }
        if (this.state.selected) {
            expandableRightBottomQuadrant(xQ, yQ, this.config.qRadius, qStyle, this.ctx);
        }

        expandableRightBottomTriangle(x, y, points, this.config.sideWidth, style, this.ctx);
    }

    getStartPosition() {
        return { x: (this.layout.x + this.layout.width) - this.config.padding - this.getOcupiedWidth(), y: (this.layout.y + this.layout.height) - this.config.padding - this.getOcupiedHeight() };
    }

    getOcupiedHeight() {
        return this.config.sideWidth + this.config.padding;
    }

    getOcupiedWidth() {
        return this.config.sideWidth + this.config.padding;
    }

    update(layout, state) {
        if (layout) this.layout = { ...this.layout, ...layout };
        if (state) this.state = { ...this.state, ...state };
    }
}
